module.exports = __webpack_public_path__ + "cf00a4fd8931e228ee086bbc7ad98458.jpg";